import request from '@/lib/request/'

const baseUri = 'careers/'

/**
 * @returns {Promise}
 */
export function getDetail () {
  return request({
    url: baseUri,
    method: 'get'
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function put (data) {
  return request({
    url: baseUri,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/careers/index.js